<div
   id="carousel-example-2"
   class="carousel slide widget-carousel-with-side-image image-full"
   style="background-image: none"
   data-ride="carousel"
>
   <app-european-moldova></app-european-moldova>
   <div class="page-wrapper position-relative">
      <ol class="carousel-indicators">
         <li data-target="#carousel-example-2" data-slide-to="1" class="active"></li>
         <li data-target="#carousel-example-2" data-slide-to="2" class=""></li>
         <li data-target="#carousel-example-2" data-slide-to="3" class=""></li>
      </ol>
      <div class="carousel-inner container" role="listbox">
         <div class="carousel-item active">
            <div class="d-flex carousel-item-container">
               <div class="slide-text-col-1 w-100 carousel-caption">
                  <div class="slide-image-col">
                     <img
                        class="d-md-block d-none w-100"
                        src="../../../assets/images/landing-page/m-delivery-4.png"
                        alt="First slide"
                     />
                     <img
                        class="d-block d-md-none w-100 mt-2"
                        src="../../../assets/images/landing-page/m-delivery-mobile-4.png"
                        alt="First slide"
                     />
                  </div>
                  <div class="overlay d-flex flex-column justify-content-center px-0 px-sm-3 px-md-5">
                     <div class="slide-text-col">
                        <h2>{{ 'public.landing-page.integrated-carriers-title' | translate }}</h2>
                        <div class="abstract mb-4">
                           {{ 'public.landing-page.integrated-carriers-content' | translate }}
                        </div>
                        <div class="buttons-group">
                           <a href="/public/integrated-service-providers" class="btn btn-primary mr-2" type="button">{{
                              'buttons.see-more' | translate
                           }}</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="carousel-item">
            <div class="d-flex carousel-item-container">
               <div class="slide-text-col-1 w-100 carousel-caption">
                  <div class="slide-image-col">
                     <img
                        class="d-md-block d-none w-100"
                        src="../../../assets/images/landing-page/m-delivery-1.png"
                        alt="Second slide"
                     />
                     <img
                        class="d-block d-md-none w-100"
                        src="../../../assets/images/landing-page/m-delivery-mobile-1.jpg"
                        alt="Second slide"
                     />
                  </div>
                  <div class="overlay d-flex flex-column justify-content-center px-0 px-sm-3 px-md-5">
                     <div class="slide-text-col">
                        <h2>{{ 'public.landing-page.how-it-works-title' | translate }}</h2>
                        <div class="abstract mb-4">
                           {{ 'public.landing-page.how-it-works-content' | translate }}
                        </div>
                        <div class="buttons-group">
                           <a href="/public/how-to-add-delivery" class="btn btn-primary mr-2" type="button">{{
                              'buttons.see-more' | translate
                           }}</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="carousel-item">
            <div class="d-flex carousel-item-container">
               <div class="slide-text-col-1 w-100 carousel-caption">
                  <div class="slide-image-col">
                     <img
                        class="d-md-block d-none w-100"
                        src="../../../assets/images/landing-page/m-delivery-2.png"
                        alt="Third slide"
                     />
                     <img
                        class="d-block d-md-none w-100"
                        src="../../../assets/images/landing-page/m-delivery-mobile-2.jpg"
                        alt="Third slide"
                     />
                  </div>
                  <div class="overlay d-flex flex-column justify-content-center px-0 px-sm-3 px-md-5">
                     <div class="slide-text-col">
                        <h2>{{ 'public.landing-page.delivery-options-title' | translate }}</h2>
                        <div class="abstract mb-4">
                           {{ 'public.landing-page.delivery-options-content' | translate }}
                        </div>
                        <div class="buttons-group">
                           <a href="/public/delivery-options" class="btn btn-primary mr-2" type="button">{{
                              'buttons.see-more' | translate
                           }}</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <a class="carousel-control-prev" href="#carousel-example-2" role="button" data-slide="prev">
         <span class="carousel-control-prev-icon" aria-hidden="true"></span>
         <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carousel-example-2" role="button" data-slide="next">
         <span class="carousel-control-next-icon" aria-hidden="true"></span>
         <span class="sr-only">Next</span>
      </a>
   </div>
</div>
<div class="sroll-text mt-4 mb-3">
   <div class="container">
      <div class="row">
         <div class="col">
            <div class="body-content bg-blue py-3 d-flex">
               <div class="content">
                  <div class="mx-2">
                     {{ translatePath + 'scroll.scroll-first' | translate }}
                  </div>
                  <div>
                     <strong>
                        {{ translatePath + 'scroll.scroll-second' | translate }}<span>29</span
                        >{{ translatePath + 'scroll.scroll-second2' | translate }}<span>50</span
                        >{{ translatePath + 'scroll.scroll-second3' | translate }}<span>100</span> lei la
                        <span>1000</span>{{ translatePath + 'scroll.scroll-second4' | translate }}
                     </strong>
                  </div>
               </div>
               <div class="content">
                  <div class="mr-2">
                     {{ translatePath + 'scroll.scroll-first' | translate }}
                  </div>
                  <div>
                     <strong>
                        {{ translatePath + 'scroll.scroll-second' | translate }}<span>29</span
                        >{{ translatePath + 'scroll.scroll-second2' | translate }}<span>50</span
                        >{{ translatePath + 'scroll.scroll-second3' | translate }}<span>100</span> lei la
                        <span>1000</span>{{ translatePath + 'scroll.scroll-second4' | translate }}
                     </strong>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
<div class="page-wrapper">
   <div class="container widget-text-and-media">
      <div class="row mb-4">
         <div class="col">
            <h4 class="title mt-auto">
               {{ translatePath + 'that-it.title' | translate }}
            </h4>
            <p class="abstract">
               {{ translatePath + 'that-it.data' | translate }}
            </p>
            <div class="buttons mb-auto">
               <button
                  class="btn justify-content-center btn-primary d-inline-flex align-items-cente"
                  [routerLink]="['/public/about-service']"
               >
                  {{ 'buttons.more' | translate | uppercase }}
               </button>
            </div>
         </div>
         <div class="col-md-6 image-column mt-4 mt-md-0">
            <div
               id="myModal"
               class="img-column video lity-toggle w-100"
               data-toggle="modal"
               data-target="#videoModal_mdelivery"
            >
               <div class="img-container rounded h-100 position-relative">
                  <img
                     class="img-cover"
                     src="../../../assets/images/ilustratie3.png"
                     alt="Video MDelivery"
                     title="Video MDelivery"
                  />

                  <div class="overlay d-flex align-items-center justify-content-center">
                     <div class="play-button">
                        <i class="fas fa-3x fa-play text-white"></i>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <h4 class="title mt-4">{{ translatePath + 'provided-services-title' | translate }}</h4>
         <div class="row">
            <div class="col-lg-5 col-md-6 d-flex flex-column text-column offset-lg-1">
               <div>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://servicii.gov.md/ro/service/003001389"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.agency-info' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://servicii.gov.md/ro/service/015000448"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.passport-info' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://servicii.gov.md/ro/service/021000337"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.record-info' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://www.asp.gov.md/ro/servicii/persoane-fizice/15/155/dn"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.child-passport' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://servicii.gov.md/ro/service/008000383"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.international-driving-licence' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://servicii.gov.md/ro/service/008000736"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.registration-certificate' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://servicii.gov.md/ro/service/015000134"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.civil-status-certificate' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://servicii.gov.md/ro/service/012000128"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.cadastral-document' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://servicii.gov.md/ro/service/015000163"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.identity-card-document' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://servicii.gov.md/ro/service/002000345"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.archive-certificates' | translate }}
                     </a>
                  </p>
               </div>
            </div>
            <div class="col-lg-5 col-md-6 d-flex flex-column text-column">
               <div>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://eat.anta.gov.md/?s=ACEMT#Service"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.cemt-permits' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://eat.anta.gov.md/?s=ABSEC#Service"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.bsec-permits' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://eat.anta.gov.md/?s=AT#Service"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.traceca-permits' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://eat.anta.gov.md/?s=CFDPTC#Service"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.cfp-roadmap-logbook' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://eat.anta.gov.md/?s=CFDPI#Service"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.interbus-roadmap-logbook' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://servicii.gov.md/ro/search?term=Autoriza%C8%9Bie%20de%20transport%20rutier%20&size=50"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.international-road-transport-permits' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://eat.anta.gov.md/?s=AP#Service"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.commuting-permits' | translate }}
                     </a>
                  </p>
                  <p>
                     <i class="fa-solid fa-arrow-up-right-from-square"></i>
                     <a
                        class="abstract text-primary"
                        href="https://eat.anta.gov.md/?s=AACEMT#Service"
                        target="_blank"
                        rel="noopener"
                     >
                        {{ 'public.integrated-sp.short-term-cemt-permit-activation' | translate }}
                     </a>
                  </p>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div class="page-wrapper">
      <div class="container widget-text-and-media ltr py-5">
         <div class="row">
            <div class="col-md-6 mb-5 mb-md-0">
               <div class="row">
                  <div class="col-12 image-column mb-4">
                     <div
                        id="myModal"
                        class="img-column video lity-toggle w-100"
                        data-toggle="modal"
                        data-target="#videoModal_pasaport"
                     >
                        <div class="img-container rounded position-relative">
                           <img
                              class="img-cover"
                              src="../../../assets/images/pasaport-min.png"
                              alt="Video MDelivery"
                              title="Video MDelivery"
                           />

                           <div class="overlay d-flex align-items-center justify-content-center">
                              <div class="play-button">
                                 <i class="fas fa-3x fa-play text-white"></i>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="col-12 d-flex flex-column text-column">
                     <h3 class="title mt-auto mb-2">
                        {{ translatePath + 'text-video.title' | translate }}
                     </h3>
                     <p class="abstract">
                        {{ translatePath + 'text-video.data' | translate }}
                     </p>
                     <div class="buttons mb-auto">
                        <a
                           class="btn justify-content-center btn-primary d-inline-flex align-items-cente"
                           href="https://www.asp.gov.md/ro/servicii/persoane-fizice/15/155"
                           target="_blank"
                           rel="noopener"
                        >
                           {{ 'buttons.read-more' | translate | uppercase }}
                        </a>
                     </div>
                  </div>
               </div>
            </div>
            <div class="col-md-6">
               <div class="row">
                  <div class="col-12 image-column mb-4">
                     <div
                        id="myModal"
                        class="img-column video lity-toggle w-100"
                        data-toggle="modal"
                        data-target="#videoModal_cazier"
                     >
                        <div class="img-container rounded position-relative">
                           <img
                              class="img-cover"
                              src="../../../assets/images/cazier-juridic-min.png"
                              alt="Video MDelivery"
                              title="Video MDelivery"
                           />

                           <div class="overlay d-flex align-items-center justify-content-center">
                              <div class="play-button">
                                 <i class="fas fa-3x fa-play text-white"></i>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="col-12 d-flex flex-column text-column">
                     <h3 class="title mt-auto mb-2">
                        {{ translatePath + 'text-video.title1' | translate }}
                     </h3>
                     <p class="abstract">
                        {{ translatePath + 'text-video.data1' | translate }}
                     </p>
                     <div class="buttons mb-auto">
                        <a
                           class="btn justify-content-center btn-primary d-inline-flex align-items-cente"
                           href="https://eservicii.gov.md/asp/dilud/cerere/CIS02"
                           target="_blank"
                           rel="noopener"
                        >
                           {{ 'buttons.read-more' | translate | uppercase }}
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="videoModal_pasaport" class="modal fade">
      <div class="modal-dialog">
         <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div class="modal-body">
               <div class="embed-responsive embed-responsive-16by9">
                  <iframe
                     id="cartoonVideo"
                     type="text/html"
                     class="embed-responsive-item"
                     title="mdelivery-video"
                     src="https://www.youtube.com/embed/NnRNGC5OIYU"
                     allowfullscreen
                  >
                  </iframe>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="videoModal_cazier" class="modal fade">
      <div class="modal-dialog">
         <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div class="modal-body">
               <div class="embed-responsive embed-responsive-16by9">
                  <iframe
                     id="cartoonVideo"
                     type="text/html"
                     title="mdelivery-video"
                     class="embed-responsive-item"
                     src="https://www.youtube.com/embed/nslfrxXj1ZI"
                     allowfullscreen
                  >
                  </iframe>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div id="videoModal_mdelivery" class="modal fade">
      <div class="modal-dialog">
         <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div class="modal-body">
               <div class="embed-responsive embed-responsive-16by9">
                  <iframe
                     id="cartoonVideo"
                     type="text/html"
                     class="embed-responsive-item"
                     title="mdelivery-video"
                     src="https://www.youtube.com/embed/w4GFuzT3sYM"
                     allowfullscreen
                  >
                  </iframe>
               </div>
            </div>
         </div>
      </div>
   </div>
   <!--
<div class="page-wrapper">
   <div class="container widget-text-and-media ltr py-5">
      <div class="col d-flex flex-column align-items-center mb-5 mt-4">
         <div class="about-box d-flex justify-content-center">
            <div class="about-box__description d-flex flex-column justify-content-around ml-3">
               <h5 class="about-box__description-title">{{ translatePath + 'that-it.title' | translate }}</h5>
               <span class="about-box__description-text">
                  {{ translatePath + 'that-it.data' | translate }}
               </span>
               <button class="about-box__description-btn" [routerLink]="['/public/about-service']">
                  {{ 'buttons.more' | translate | uppercase }}
               </button>
            </div>
            <div class="about-box__img mr-5"><img src="./../../../assets/images/ilustratie2.jpg" /></div>
         </div>
      </div>
   </div>
</div> -->
   <!-- #Media: END-->

   <!-- <div class="container widget-text-and-media ltr py-5">
   <div class="row">
      <div class="col d-flex align-items-center flex-column">
         <h3 class="mb-5 col-title">{{ translatePath + 'benefits.title' | translate }}</h3>

         <div class="col feature d-flex flex-column align-items-center mt-5">
            <div class="feature-item d-flex justify-content-xl-between justify-content-center mb-4 flex-wrap">
               <div class="feature-item__box">
                  <div class="feature-item__box-icon d-flex justify-content-center">
                     <img src="./../../../assets/images/flexibilitate.svg" />
                  </div>
                  <div class="feature-item__box-title mt-3">
                     <h5>{{ translatePath + 'benefits.title1' | translate }}</h5>
                  </div>
                  <div class="feature-item__box-description">
                     <span>{{ translatePath + 'benefits.data1' | translate }}</span>
                  </div>
               </div>

               <div class="feature-item__box">
                  <div class="feature-item__box-icon d-flex justify-content-center">
                     <img src="./../../../assets/images/disponibilitate.svg" />
                  </div>
                  <div class="feature-item__box-title mt-3">
                     <h5>{{ translatePath + 'benefits.title2' | translate }}</h5>
                  </div>
                  <div class="feature-item__box-description">
                     <span>{{ translatePath + 'benefits.data2' | translate }}</span>
                  </div>
               </div>

               <div class="feature-item__box">
                  <div class="feature-item__box-icon d-flex justify-content-center">
                     <img src="./../../../assets/images/transparenta.svg" />
                  </div>
                  <div class="feature-item__box-title mt-3">
                     <h5>{{ translatePath + 'benefits.title3' | translate }}</h5>
                  </div>
                  <div class="feature-item__box-description">
                     <span>{{ translatePath + 'benefits.data3' | translate }}</span>
                  </div>
               </div>

               <div class="feature-item__box">
                  <div class="feature-item__box-icon d-flex justify-content-center">
                     <img src="./../../../assets/images/rapiditate.svg" />
                  </div>
                  <div class="feature-item__box-title mt-3">
                     <h5>{{ translatePath + 'benefits.title4' | translate }}</h5>
                  </div>
                  <div class="feature-item__box-description">
                     <span>{{ translatePath + 'benefits.data4' | translate }}</span>
                  </div>
               </div>
            </div>

            <div class="feature-item d-flex justify-content-xl-between flex-wrap justify-content-center">
               <div class="feature-item__box">
                  <div class="feature-item__box-icon d-flex justify-content-center">
                     <img src="./../../../assets/images/accesibilitate.svg" />
                  </div>
                  <div class="feature-item__box-title mt-3">
                     <h5>{{ translatePath + 'benefits.title5' | translate }}</h5>
                  </div>
                  <div class="feature-item__box-description">
                     <span> {{ translatePath + 'benefits.data5' | translate }} </span>
                  </div>
               </div>

               <div class="feature-item__box">
                  <div class="feature-item__box-icon d-flex justify-content-center">
                     <img src="./../../../assets/images/monitorizare.svg" />
                  </div>
                  <div class="feature-item__box-title mt-3">
                     <h5>{{ translatePath + 'benefits.title6' | translate }}</h5>
                  </div>
                  <div class="feature-item__box-description">
                     <span> {{ translatePath + 'benefits.data6' | translate }} </span>
                  </div>
               </div>

               <div class="feature-item__box">
                  <div class="feature-item__box-icon d-flex justify-content-center">
                     <img src="./../../../assets/images/acoperire.svg" />
                  </div>
                  <div class="feature-item__box-title mt-3">
                     <h5>{{ translatePath + 'benefits.title7' | translate }}</h5>
                  </div>
                  <div class="feature-item__box-description">
                     <span> {{ translatePath + 'benefits.data7' | translate }} </span>
                  </div>
               </div>

               <div class="feature-item__box">
                  <div class="feature-item__box-icon d-flex justify-content-center">
                     <img src="./../../../assets/images/siguranta.svg" />
                  </div>
                  <div class="feature-item__box-title mt-3">
                     <h5>{{ translatePath + 'benefits.title8' | translate }}</h5>
                  </div>
                  <div class="feature-item__box-description">
                     <span> {{ translatePath + 'benefits.data8' | translate }} </span>
                  </div>
               </div>
            </div>
         </div>
      -->
   <!-- </div>
      <div class="col-lg-5 col-md-6 d-flex flex-column image-column">
      <img src="./../../../assets/images/Layer-401.jpg.png" alt="Image" title="Image Title" class="img-fluid" />
      </div>
      <div class="col-lg-6 col-md-6 offset-lg-1 text-column">
      <h3 class="title mt-auto">MDelivery Noutati</h3>
      <p class="abstract">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut nisl pretium, pulvinar nisi sed, placerat
      nibh. Nam egestas nisi quis ligula dapibus, a laoreet augue aliquam.
      </p>
      <div class="buttons mb-auto">
      <button type="button" class="btn btn-primary">{{ 'buttons.more' | translate }}</button>
         </div>
      </div>
   </div>
</div>
<div class="container widget-text-and-media ltr py-5">
   <div class="row">
         <div class="col-lg-5 col-md-6 d-flex flex-column text-column">
            <h3 class="title mt-auto">MDelivery Noutati</h3>
            <p class="abstract">
               Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut nisl pretium, pulvinar nisi sed, placerat
               nibh. Nam egestas nisi quis ligula dapibus, a laoreet augue aliquam.
            </p>
            <div class="buttons mb-auto">
               <button type="button" class="btn btn-primary">{{ 'buttons.more' | translate }}</button>
            </div>
         </div>
         <div class="col-lg-6 col-md-6 offset-lg-1 image-column">
            <img src="./../../../assets/images/Layer-401.jpg.png" alt="Image" title="Image Title" class="img-fluid" />
         </div>
   </div>
</div> -->
</div>
